export const LANGUAGE_SET = 'auth/LANGUAGE_SET';
export const IS_GOOGLE_MAP_SCRIPT_LOADED_SET = 'auth/IS_GOOGLE_MAP_SCRIPT_LOADED_SET';
